import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { postResolucion } from '../../../redux/actions';
import styles from './Resolverticket.module.css';
import { format } from 'date-fns';
import PacmanLoader from 'react-spinners/PacmanLoader';
import Swal from 'sweetalert2';

const repuestosList = [
    "ABRAZADERAS", "ACEITE", "AGUA", "ALMALGAMADOR", "ANHIDRONA LECOSORB", "ANTORCHA", "ASPA", "BATERIA", "BLOWER",
    "BOAD STOP", "BUSHING", "CABLEADOS", "CELDA", "CINTA ANTI ADERENTE", "CINTA VINIL", "CONTACTOR", "CORREAS",
    "DISPLAY O CABEZOTE", "EMPAQUES", "EMPAQUES DE BALLAST", "EMPAQUES DE TUBO DE COMBUSTION EXTERNO",
    "EMPAQUES DE TUBO DE COMBUSTION INTERNO", "EMPAQUES DE TUBOS DE COMBUSTION", "ESCOBILLA", "FILTRO",
    "FILTRO DE PARTICULAS", "FILTROS", "FUSIBLES", "GAS REFRIGERANTE", "GUARDA MOTOR", "IMAN INFERIOR",
    "IMAN SUPERIOR", "LAMAPAR UV", "LANZA","LAMPARA", "LLANTAS", "MANDIBULAS", "MANGUERAS", "MARTILLOS", "MOTOR",
    "NEBULIZADOR", "POTENCIOMETRO", "PUENTE RETIFICADOR", "REACTIVOS TUBOS DE CATALIZADOR",
    "REACTIVOS TUBOS DE COMBUSTION", "RELE ESTADO SOLIDO", "RESISTENCIA", "RODAMIENTOS", "RUBATEX",
    "SENSOR DE NIVEL", "SENSORES E INTERRUPTOR", "SOLDADURA", "TARJETA CONTROLADORA", "TERMOCUPLA",
    "TORNILLERIA", "TUBO DE COMBUSTION", "TUBO DE COMBUSTION EXTERNO", "TUBO DE COMBUSTION INTERNO",
    "UNIDAD", "VALVULA DE PELLISCO", "VENTILADOR EXTRACTOR", "VIDRIO DE VISION", "VOLANTA", "WASHER", "OTRO"
];

const actividadesMto = [
    "Revisión general funcionamiento",
    "Limpieza general",
    "Revision temperatura",
    "Revisión del sistema de seguridad",
    "Revisión del sistema de enfriamiento",
    "Lubricación",
    "Otra"
];

const Resolverticket = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { nombre, fecha, tecnico, UsuarioId, email, observacion1 } = location.state;

    const [formData, setFormData] = useState({
        observaciones: '', // Observaciones Ticket (Existing)
        observaciones_gen: '', // Observaciones generales y/o recomendaciones (New)
        actividad: [],
        otra_actividad: '',
        revvoltaje: '',
        repuesto: '',
        otro_repuesto: '',
        en_compania: false,
        num_personas: ''
    });

    const [loading, setLoading] = useState(false);

    const handleBack = () => {
        navigate('/asigtecmto');
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            if (name === 'actividad') {
                setFormData(prevState => ({
                    ...prevState,
                    actividad: checked
                        ? [...prevState.actividad, value]
                        : prevState.actividad.filter(v => v !== value)
                }));
            } else {
                setFormData(prevState => ({
                    ...prevState,
                    [name]: checked
                }));
            }
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.observaciones_gen.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Las observaciones generales son obligatorias.'
            });
            return;
        }

        const resolucionData = {
            observacion: formData.observaciones, // Existing observacion field used for current ticket info
            observaciones_gen: formData.observaciones_gen,
            TicketId: location.pathname.split('/').pop(),
            EstadoId: 4,
            UsuarioId,
            email,
            nombre,
            tecnico,
            // Mto Fields mapping
            revgenfuncion: formData.actividad.includes('Revisión general funcionamiento') ? 1 : 0,
            limpgeneral: formData.actividad.includes('Limpieza general') ? 1 : 0,
            revtemperatura: formData.actividad.includes('Revision temperatura') ? 1 : 0,
            revsisseguridad: formData.actividad.includes('Revisión del sistema de seguridad') ? 1 : 0,
            revsisenfriamiento: formData.actividad.includes('Revisión del sistema de enfriamiento') ? 1 : 0,
            lubricacion: formData.actividad.includes('Lubricación') ? 1 : 0,
            otra_actividad: formData.actividad.includes('Otra') ? formData.otra_actividad : '',
            revvoltaje: formData.revvoltaje,
            repuesto: formData.repuesto,
            otro_repuesto: formData.repuesto === 'OTRO' ? formData.otro_repuesto : '',
            en_compania: formData.en_compania ? 1 : 0,
            num_personas: formData.en_compania ? formData.num_personas : 0,
            mto:1
        };

        setLoading(true);

        dispatch(postResolucion(resolucionData))
            .then(() => {
                setLoading(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Resolución de Ticket Exitosa',
                    confirmButtonText: 'Aceptar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/asigtecmto');
                    }
                });
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un problema al enviar la resolución.',
                    confirmButtonText: 'Aceptar'
                });
            });
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return format(date, 'yyyy-MM-dd HH:mm:ss');
    };

    return (
        <div className={styles.container}>
            {loading && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <PacmanLoader color="#6366f1" size={25} />
                </div>
            )}
            <FaArrowLeft className={styles.backIcon} onClick={handleBack} />
            <h2>Resolución de Ticket Mantenimiento</h2>

            <form onSubmit={handleSubmit}>
                <fieldset className={styles.fieldset}>
                    <legend>Información del Ticket # {location.pathname.split('/').pop()}</legend>
                    <div className={styles.infoRow}>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Usuario</span>
                            <span className={styles.infoValue}>{nombre}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Fecha</span>
                            <span className={styles.infoValue}>{formatDateTime(fecha)}</span>
                        </div>
                        <div className={styles.infoItem}>
                            <span className={styles.infoLabel}>Técnico</span>
                            <span className={styles.infoValue}>{tecnico}</span>
                        </div>
                    </div>
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Actividades Realizadas</legend>
                    <div className={styles.checkboxGroup}>
                        {actividadesMto.map(activity => (
                            <label key={activity} className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    name="actividad"
                                    value={activity}
                                    checked={formData.actividad.includes(activity)}
                                    onChange={handleChange}
                                />
                                {activity}
                            </label>
                        ))}
                    </div>

                    {formData.actividad.includes('Otra') && (
                        <div className={`${styles.inputGroup} ${styles.visibleField}`}>
                            <label>Especifique Otra Actividad:</label>
                            <input
                                className={styles.input}
                                name="otra_actividad"
                                value={formData.otra_actividad}
                                onChange={handleChange}
                                placeholder="Describa la actividad..."
                            />
                        </div>
                    )}
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Mediciones</legend>
                    <div className={styles.inputGroup}>
                        <label>Revisión de Voltaje:</label>
                        <textarea
                            className={styles.textarea}
                            name="revvoltaje"
                            value={formData.revvoltaje}
                            onChange={handleChange}
                            placeholder="Ingrese los valores de voltaje medidos..."
                        />
                    </div>
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Repuestos</legend>
                    <div className={styles.inputGroup}>
                        <label>Seleccione Repuesto:</label>
                        <select
                            className={styles.select}
                            name="repuesto"
                            value={formData.repuesto}
                            onChange={handleChange}
                        >
                            <option value="">-- Seleccione un repuesto --</option>
                            {repuestosList.map(item => (
                                <option key={item} value={item}>{item}</option>
                            ))}
                        </select>
                    </div>

                    {formData.repuesto === 'OTRO' && (
                        <div className={`${styles.inputGroup} ${styles.visibleField}`}>
                            <label>Especifique Otro Repuesto:</label>
                            <textarea
                                className={styles.textarea}
                                name="otro_repuesto"
                                value={formData.otro_repuesto}
                                onChange={handleChange}
                                placeholder="Describa el repuesto utilizado..."
                            />
                        </div>
                    )}
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Colaboración</legend>
                    <div className={styles.checkboxGroup}>
                        <label className={styles.checkboxLabel}>
                            <input
                                type="checkbox"
                                name="en_compania"
                                checked={formData.en_compania}
                                onChange={handleChange}
                            />
                            Actividades realizadas en compañía
                        </label>
                    </div>

                    {formData.en_compania && (
                        <div className={`${styles.inputGroup} ${styles.visibleField}`}>
                            <label>N° de personas:</label>
                            <input
                                type="number"
                                className={styles.input}
                                name="num_personas"
                                value={formData.num_personas}
                                onChange={handleChange}
                                placeholder="Cantidad de personas..."
                            />
                        </div>
                    )}
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Observaciones del Ticket</legend>
                    <textarea
                        className={styles.textarea}
                        name="observaciones_ticket_original"
                        value={observacion1}
                        readOnly
                        style={{ backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
                    />
                </fieldset>

                <fieldset className={styles.fieldset}>
                    <legend>Observaciones Generales y/o Recomendaciones</legend>
                    <textarea
                        className={styles.textarea}
                        name="observaciones_gen"
                        value={formData.observaciones_gen}
                        onChange={handleChange}
                        placeholder="Escriba aquí las observaciones finales o recomendaciones técnicas..."
                    />
                </fieldset>

                <button type="submit" className={styles.button}>Enviar Solución</button>
            </form>
        </div>
    );
};

export default Resolverticket;
